const AboutUs2Api=[
    {
        id:1,
        title:"The Fastest Way to Pay Online",
        info: "Recharge & pay bills, book flights & movie tickets, open a savings account, invest in stocks & mutual funds, and do a lot more."
    },
    {
        id:2,
        title:"Pay directly from your bank account",
        info: "OnlinePay Payments Bank offers secure, transparent and risk-free banking at your fingertips. With instant account opening, virtual debit card and zero balance requirements, experience the future of banking today."
    },
    {
        id:3,
        title:"Insurance made easy.",
        info: "Buying insurance does not have to be tedious, time-consuming & confusing. Paytm Insurance removes the worry of getting insured by making it simple, convenient & easy-to-understand."
    }
]

export default AboutUs2Api